// "error" is the silent-SSO (prompt=none) case: no token to hand back,
// just a defined interaction-required result the consumer must check for
// before assuming "login"/"logout" is present -- see Consumer
// Authentication Integration docs, "error" is a reserved callback param.
export type AuthCallbackAction = "login" | "logout" | "error";

/** Preserve the consumer's route while adding a short-lived callback token. */
export const buildAuthCallbackUrl = (referer: string, action: AuthCallbackAction, token: string) => {
  const callback = new URL(referer);
  callback.searchParams.set(action, token);
  return callback.toString();
};
